import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex md:flex-row flex-col items-center md:space-x-3 md:space-y-0 space-y-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Edit", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "View PDF", -1)
const _hoisted_4 = { class: "mt-6 md:text-2xl text-lg font-medium text-neutral-600" }
const _hoisted_5 = { class: "md:inline-block block font-semibold text-neutral-900" }
const _hoisted_6 = {
  key: 0,
  class: "w-full lg:p-6 p-4 mx-auto my-6 border border-gray-200 rounded"
}
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "grid grid-cols-6 md:gap-6 gap-8 mt-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 border-t border-gray-200" }, null, -1)
const _hoisted_10 = { class: "grid grid-cols-6 col-span-6 md:gap-6 gap-3 px-4 md:py-6 py-4 border border-gray-200 rounded-lg" }
const _hoisted_11 = { class: "grid grid-cols-3 md:col-span-3 col-span-6 gap-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Case Number:")
], -1)
const _hoisted_13 = { class: "col-span-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Full Name:")
], -1)
const _hoisted_15 = { class: "col-span-2" }
const _hoisted_16 = { class: "grid grid-cols-3 md:col-span-3 col-span-6 gap-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Date Initiated:")
], -1)
const _hoisted_18 = { class: "col-span-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Assessment is for patient's sibling:")
], -1)
const _hoisted_20 = { class: "col-span-2" }
const _hoisted_21 = { class: "grid grid-cols-6 col-span-6 gap-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Appointments:")
], -1)
const _hoisted_23 = { class: "col-span-5" }
const _hoisted_24 = { class: "grid grid-cols-6 col-span-6 px-4 py-6 border border-gray-200 rounded-lg md:gap-9 gap-8" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 -mb-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold" }, "Safety Factor")
], -1)
const _hoisted_26 = { class: "md:col-span-3 col-span-6" }
const _hoisted_27 = { class: "font-medium text-neutral-600" }
const _hoisted_28 = { class: "flex items-center md:col-span-3 col-span-6" }
const _hoisted_29 = { class: "flex items-center space-x-6" }
const _hoisted_30 = { class: "col-span-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "block mb-3 font-semibold text-neutral-600" }, " Information supporting safety factor: ", -1)
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { class: "col-span-6" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "block mb-3 font-semibold text-neutral-600" }, "Brief Family Background", -1)
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "col-span-6" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "block mb-3 font-semibold text-neutral-600" }, "Family Background", -1)
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 md:mb-0 -mb-5" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold" }, "Safety Decision Plan")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold" }, "Risk Codes")
], -1)
const _hoisted_41 = { class: "md:col-span-2 col-span-6 md:mb-0 -mb-5" }
const _hoisted_42 = { class: "md:col-span-2 col-span-6 md:mb-0 -mb-5" }
const _hoisted_43 = { class: "md:col-span-2 col-span-6" }
const _hoisted_44 = {
  for: "action_plan-1",
  class: "relative flex items-center h-full py-3 pl-3 pr-12 border rounded cursor-pointer border-neutral-100"
}
const _hoisted_45 = { class: "text-xs font-medium text-neutral-600" }
const _hoisted_46 = ["checked", "name", "id"]
const _hoisted_47 = { class: "col-span-6" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", { class: "block mb-3 font-semibold text-neutral-600" }, "Immediate Safety Plan", -1)
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { class: "col-span-6" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", { class: "block mb-3 font-semibold text-neutral-600" }, " Rationale of Overall Immediate Safety Assessment ", -1)
const _hoisted_52 = ["innerHTML"]

import { ref, computed } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import { EyeIcon } from "@heroicons/vue/24/solid";
import { useRouter, useRoute } from "vue-router";
import SafetyAssessment from "@/classes/Cases/SafetyAssessment";
import { renderSelect, renderSelectV2 } from "@/interfaces/DropdownInterface"; 
import { SafetyAssessmentStatus } from "@/views/enums/SafetyAssessmentStatus";
import pickBy from "lodash/pickBy";
import { onIonViewWillEnter } from "@ionic/vue";
import PencilUnderlineIcon from "@/components/icons/pencilUnderlineIcon.vue";

/******************************** For Offline Imports ***************************** */
import CaseImmediateService from "@/classes/Cases/CaseImmediateAssessment/CaseImmediateService"; 
import { useNetworkStore } from "@/store/network"; 
import AssessmentOfflineProcessor from "@/classes/Cases/CaseImmediateAssessment/Processor/OfflineProcessor";

export default /*#__PURE__*/_defineComponent({
  __name: 'ViewPage',
  setup(__props) {

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
/********************************************************************************** */
const router = useRouter();
const route = useRoute();
const loaded = ref<boolean>(false);
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const assessmentId = ref<number | null>(route.params.assessment);
const questions = ref<renderSelect[]>([]);
const riskCodes = ref<renderSelect[]>([]);
const safetyFactorOptions = ref<renderSelectV2[]>([]);
const item = ref<any>();

const template = (items: object): void => {   
	item.value.safety_assessment_questions = questions.value?.map((item) => {
		const newForm = items?.safety_assessment_questions?.filter((question:any) => {
			if (question.question_id == item.id) { 
				return {
					question_id: question.question_id,
					supporting_information: question.supporting_information,
					status: question.status,
				};
			}
		});
		return newForm.length > 0
			? newForm[0]
			: { question_id: item.id, supporting_information: null, status: SafetyAssessmentStatus.UNKNOWN };
	}); 
};

const getData = async (): void => { 
	await CaseImmediateService.edit(
		patientId.value,
		caseId.value,
		assessmentId.value,
		isNetworkAvailable.value,
		pickBy({ ...{ rows: 10 } })
	)
		.then(async (response: object) => {
            // redirect to create page if offline
            if (!isNetworkAvailable.value && !response.data.item?.case_number) {
                return router.push(`/patient/${patientId.value}/cases/${caseId.value}/safety-assessment/create`);
            }
			console.log("response from eid", response.data.item.safety_assessment_questions)
			safetyFactorOptions.value = response.data.status;
			questions.value = response.data.questions;
			riskCodes.value = response.data.riskCodes;
			item.value = response.data.item;  
			console.log(questions.value);
			template(response.data.item);
            await syncToOffline();
			loaded.value = true;
		})
		.catch((error: object) => console.log(error));
};

const syncToOffline = async () => {
    if (isNetworkAvailable.value) {
        item.value.questions = item.value.safety_assessment_questions;
        await AssessmentOfflineProcessor.syncToOffline(caseId.value, item.value);
    }

}

const generatePDFAccess = ():void => {
	SafetyAssessment
		.generatePDFAccess(
			patientId.value,
			caseId.value,
			assessmentId.value 
		)
		.then(({data}) => {
			if(data.token){
				downloadPDF(data.token)
			}
		}).catch((errors) => {
			console.log(errors);
		})

}
const downloadPDF = (token:string):void => {
	SafetyAssessment
		.downloadPDF(
			assessmentId.value,
			token 
		)
		.then(({data}) => {
			console.log(data);
		}).catch((errors) => {
			console.log(errors);
		})

}
 
onIonViewWillEnter(() => getData()); 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backLink: `/patient/${patientId.value}/cases/${caseId.value}/edit`,
    hasBackClass: "flex md:justify-between md:items-center md:flex-row flex-col"
  }, {
    lowerRight: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (
						_unref(router).replace(
							`/patient/${patientId.value}/cases/${caseId.value}/safety-assessment/${assessmentId.value}/create`
						)
					)),
          class: "md:w-auto w-full md:mt-0 mt-6"
        }, [
          _createVNode(ButtonComponent, { customClass: "primary md:w-auto w-full" }, {
            default: _withCtx(() => [
              _createVNode(PencilUnderlineIcon, { class: "object-contain w-4 h-4 mr-1 icon" }),
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        (isNetworkAvailable.value)
          ? (_openBlock(), _createBlock(ButtonComponent, {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (generatePDFAccess())),
              size: "large",
              customClass: "bg-green-600 hover:bg-green-700 text-white transition border border-green-600 hover:border-green-700 md:w-auto w-full md:mt-0 mt-6"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(EyeIcon), { class: "w-5 h-5 mr-2 -ml-1 icon" }),
                _hoisted_3
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_4, [
        _createTextVNode("Patient's Name: "),
        _createElementVNode("span", _hoisted_5, _toDisplayString(item.value?.name), 1)
      ]),
      (loaded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(SectionTitle, { title: "Immediate Safety Assessment" })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("p", null, _toDisplayString(item.value?.case_number), 1)
                  ]),
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("p", null, _toDisplayString(item.value?.name), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("p", null, _toDisplayString(item.value?.assessment_date), 1)
                  ]),
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("p", null, _toDisplayString(item.value?.is_assessment_patient_sibling ? "Yes" : "No"), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("p", null, _toDisplayString(item.value?.appointment), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (question, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "grid grid-cols-6 col-span-6 gap-6",
                    key: question
                  }, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("p", _hoisted_27, _toDisplayString(question.description), 1)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(RadioGroup, {
                          options: safetyFactorOptions.value,
                          name: `caretaker_${index}`,
                          readonly: "",
                          modelValue: item.value.safety_assessment_questions[index]['status'],
                          "onUpdate:modelValue": ($event: any) => ((item.value.safety_assessment_questions[index]['status']) = $event)
                        }, null, 8, ["options", "name", "modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("div", {
                        innerHTML: item.value?.safety_assessment_questions[index]['supporting_information'],
                        class: "frm-description"
                      }, null, 8, _hoisted_32)
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", {
                  innerHTML: item.value?.brief_family_background,
                  class: "frm-description"
                }, null, 8, _hoisted_35)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", {
                  innerHTML: item.value?.family_background,
                  class: "frm-description"
                }, null, 8, _hoisted_38)
              ]),
              _hoisted_39,
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                _createVNode(TextInput, {
                  disabled: true,
                  type: "number",
                  label: "Total number of “Yes”",
                  placeholder: "#",
                  name: "number_yes",
                  id: "number_yes",
                  modelValue: item.value.yes_count,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.yes_count) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createVNode(TextInput, {
                  disabled: true,
                  type: "number",
                  label: "Total number of “No”",
                  placeholder: "#",
                  name: "number_no",
                  modelValue: item.value.no_count,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.no_count) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createVNode(TextInput, {
                  disabled: true,
                  type: "number",
                  label: "Total number of “Unknown”",
                  placeholder: "#",
                  name: "number_unknown",
                  modelValue: item.value.unknown_count,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((item.value.unknown_count) = $event))
                }, null, 8, ["modelValue"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(riskCodes.value, (riskCode, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "md:col-span-2 col-span-6",
                  key: riskCode
                }, [
                  _createElementVNode("label", _hoisted_44, [
                    _createElementVNode("p", _hoisted_45, _toDisplayString(riskCode.description), 1),
                    _createElementVNode("input", {
                      checked: item.value.risk_code_id == riskCode.id ? true : false,
                      disabled: "",
                      type: "radio",
                      name: `action_plan_${index}`,
                      id: `action_plan_${index}`,
                      class: "absolute z-10 w-6 h-6 border-gray-300 cursor-pointer top-3 right-3 text-primary-600 focus:ring-0 focus:ring-offset-0 focus:outline-0 focus:outline-offset-0 checked:border-primary-600"
                    }, null, 8, _hoisted_46)
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", {
                  innerHTML: item.value.immediate_safety_plan,
                  class: "frm-description"
                }, null, 8, _hoisted_49)
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", {
                  innerHTML: item.value.overall_risk_assessment,
                  class: "frm-description"
                }, null, 8, _hoisted_52)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["backLink"]))
}
}

})